import { REDUX_STATUS } from '@gymaholic/packages'
import setUtil from 'utils/set'
import { getObjectUtil } from 'packages/src'

function loadErrorInstance (state, action) {
  const {
    error,
    path
  } = action.payload
  return setUtil(state, path, {
    ...getObjectUtil(state, path),
    status: REDUX_STATUS.ERROR,
    error,
    validation: null
  })
}

function loadErrorDomain (state, action) {
  const {
    error,
    domainListPath
  } = action.payload
  return setUtil(state, domainListPath, {
    ...getObjectUtil(state, domainListPath),
    status: REDUX_STATUS.ERROR,
    error
  })
}

function loadErrorReduxReducer (state, action) {
  const {
    path
  } = action.payload
  if (path) {
    return loadErrorInstance(state, action)
  }
  return loadErrorDomain(state, action)
}

export {
  loadErrorReduxReducer
}
